/**
 * Constants for communication actions.
 * URL in these constants are having dynamic variables
 * wrapped in {}, replace them with original dynamic variables
 * in order to send API requests.
 */
export const SCHEDULE_LIST_URL =
  "/communication/ims/schedule/list?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const SCHEDULE_DATA_URL = "/communication/ims/schedule/data";
export const PLAN_LIST_URL = "/communication/ims/schedule/schemes";
export const ADD_SCHEDULE_URL = "/communication/ims/schedule/add";
export const CSV_RENDER_EMAIL_URL =
  "/communication/ims/schedule/upload/partner?emailGroupTypeId={emailGroupTypeId}&division={division}&channel={channel}&planAssociationId={planAssociationId}&isSchemeBased={isSchemeBased}";
export const DELETE_COMMUNICATION_SCHEDULE_URL =
  "/communication/ims/schedule/delete?scheduleNumber={scheduleNumber}";
export const DELETE_PLAN_LIST_SCHEDULE_URL =
  "/communication/ims/schedulePlanList/associated/plans/delete/";
export const DELETE_PARTNER_HO_SALES_LIST_EMAIL_URL =
  "/communication/ims/schedulePlanList/delete/associated/emailGroups";
export const DELETE_SCHEDULE_ATTACHMENT_URL =
  "/communication/ims/schedule/attachment?fileID={payload}";
export const SCHEDULE_ATTACHMENT_UPLOAD_URL =
  "/communication/ims/schedule/attachment?scheduleNo={scheduleNumber}";
export const SCHEDULE_ATTACHMENT_URL =
  "/communication/ims/schedule/attachment/list?scheduleNumber={payload}";
export const PLAN_RENDER_EMAIL_URL =
  "/communication/ims/schedule/renderEmail?groupId={groupId}&planNumber={planNumber}&planAssociationId={planAssociationId}";
export const GROUP_RENDER_EMAIL_URL =
  "/communication/ims/email-master/groups/{payload}/emails?groupTypeLkpId={groupTypeLkpId}&planAssociationId={planAssociationId}";
export const SCHEDULE_GENERAL_DATA_DETAILS_URL =
  "/communication/ims/schedule/schedulenumber?scheduleNumber={payload}";
export const SAVE_PLAN_LIST_DATA_URL =
  "/communication/ims/schedule/add/email/plan?{str}";
export const SAVE_HO_MX_PLAN_LIST_URL =
  "/communication/ims/schedule/add/hoemail/plan?{str}";
export const SCHEDULE_PLAN_LIST_DETAILS_URL =
  "/communication/ims/schedule/scheduledPlans?scheduleNumber={payload}";
export const GROUP_LIST_DROPDOWN_URL =
  "/communication/ims/email-master/listGroups?groupTypeLookUpId={payload}&division={division}";
export const ADD_SCHEDULE_PLAN_URL = "/communication/ims/schedule/addPlan";
export const SAVE_SUBMITTED_SCHEDULE_URL =
  "/communication/ims/schedule/submitschedule";
export const PLAN_ASSOCIATED_EMAIL_URL =
  "/communication/ims/schedulePlanList/linked/email?emailGroupTypeId={emailGroupTypeId}&planNumber={planNumber}&scheduleNumber={scheduleNumber}&pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const FLAG_FOR_EMAIL_PLAN_OR_GROUP_URL =
  "/communication/ims/schedulePlanList/emailType/flag?emailGroupTypeId={emailGroupTypeId}&planNumber={planNumber}&scheduleNumber={scheduleNumber}";
export const PLAN_ASSOCIATION_EMAIL_GROUP_URL =
  "/communication/ims/schedulePlanList/linked/email/group?emailGroupTypeId={emailGroupTypeId}&planNumber={planNumber}&scheduleNumber={scheduleNumber}&planAssociationId={planAssociationId}";
export const GET_EMAIL_RENDER_SINGLE_LIST_URL = 
  "/communication/ims/schedule/list/{planAssociationId}/{groupTypeLkpId}?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}&scheduleMailingGroupId={scheduleMailingGroupId}";
export const GET_EMAIL_RENDER_MULTI_LIST_URL = 
  "/communication/ims/schedule/list/{planAssociationId}/{groupTypeLkpId}?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const ASSOCIATED_GROUP_BASED_EMAILS_URL =
  "/communication/ims/schedulePlanList/linked/grpNum/emails?emailGrpType={emailGroupTypeId}&groupNumber={groupNumber}&planNumber={planNumber}&scheduleNumber={scheduleNumber}&pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const SUBMIT_SCHEDULE_DETAILS_URL =
  "/communication/ims/schedule/get/submitschedule?scheduleNo={payload}";
export const EMAIL_ATTACHMENT_EXPORT_FILE_URL =
  "/communication/ims/schedule/attachment/{fileId}?scheduleNo={scheduleNo}";
export const PARTNER_ONLY_EXPORT_PAYOUT_COMMUNICATION =
  "/communication/ims/payoutCommunication/exportPartnerEmailsWithNoMailingData?";
export const DOWNLOAD_GROUP_PARTNER_HO_SALES_FILE_URL =
  "/communication/ims/schedule/download/planbased?groupId={groupTypeId}&groupNo={groupNo}&planAssociationId={planAssociationId}";
export const DOWNLOAD_PLANNED_PARTNER_SALES_FILE_URL =
  "/communication/ims/schedule/download/planbased?groupId={groupTypeId}&planNumber={planNumber}&planAssociationId={planAssociationId}";
export const DOWNLOAD_GROUP_PARTNER_HO_SALES_FILE_AFTER_SAVE_URL =
  "/communication/ims/schedulePlanList/linked/grpNum/emails/export?groupId={groupTypeId}&groupNo={groupNo}&planAssociationId={planAssociationId}";
export const DOWNLOAD_PLANNED_PARTNER_SALES_FILE_AFTER_SAVE_URL =
  "/communication/ims/schedulePlanList/linked/grpNum/emails/export?groupId={groupTypeId}&planNumber={planNumber}&planAssociationId={planAssociationId}";
export const DOWNLOAD_PARTNER_FILE_URL =
  "/communication/ims/schedule/download/planbased?groupId={groupTypeId}&groupNo={groupNo}&planAssociationId={planAssociationId}";
export const DOWNLOAD_HO_FILE_URL =
  "/communication/ims/schedule/download/planbased?groupId={groupTypeId}&groupNo={groupNo}&planAssociationId={planAssociationId}";
export const DOWNLOAD_SALES_FILE_URL =
  "/communication/ims/schedule/download/planbased?groupId={groupTypeId}&groupNo={groupNo}&planAssociationId={planAssociationId}";
export const ROLES_PARTNER_LIST_URL =
  "/communication/ims/schedule/jobRoleNames?divisionId={divisionId}&audience={audience}&channel={channelId}";
export const CANCEL_SUBMIT_SCHDEULE =
  "/communication/ims/schedule/cancelSchedule?scheduleNumber={scheduleNumber}";
export const SCHEME_PAYOUT_SCHEDULE_URL =
  "/communication/ims/payoutCommunication/save";
export const PAYOUT_COMMUNICATION_PARTNER =
  "/communication/ims/payoutCommunication/schedulePartnerEmails?{payload}";
export const PAYOUT_COMMUNICATION_SALES =
  "/communication/ims/payoutCommunication/scheduleSalesTeamEmails?{payload}";
export const PAYOUT_COMMUNICATION_HO =
  "/communication/ims/payoutCommunication/scheduleHoTeamEmails?{payload}";
export const PAYOUT_COMMUNICATION_SAVE_RENDER_EMAIL =
  "/communication/ims/payoutCommunication/renderEmail";
export const PAYOUT_COMMUNICATION_SALES_SYNC =
  "/communication/ims/payoutCommunication/renderEmail?syncFlag={payload}";
export const PAYOUT_COMMUNICATION_SAVE_SUBMIT_SCHEDULE =
  "/communication/ims/payoutCommunication/schedule";
export const PAYOUT_COMMUNICATION_DELETE_GROUP =
  "/communication/ims/payoutCommunication/delete/{groupTypeId}";
export const PAYOUT_COMMUNICATION_SCHEDULE =
  "/communication/ims/payoutCommunication/schedule?{payload}";
export const PAYOUT_COMMUNICATION_SAVE_RENDER_ALL_SCHEDULE =
  "/communication/ims/payoutCommunication/asyncSaveEmailsForPayout";
export const PAYOUT_COMMUNICATION_ADD_PAYOUT_GROUP =
  "/communication/ims/payoutCommunication/saveScheduledPartnerHoSalesEmails";
export const PAYOUT_COMMUNICATION_GET_DROPDOWN_PARTNER_HO_SALE =
  "/communication/ims/payoutCommunication/getRenderedPartnerHoAndSales?{payload}";
  export const EMAIL_HO_GROUP_PAYOUT_COMM =
  "/communication/ims/email-master/emailHoGroupsPayoutComm?division={division}&scheduleId={scheduleId}&channel={channel}";
export const USER_CODE_LIST = 
  "/communication/ims/payoutCommunication/payoutUsers?userCode={search}";
export const PLAN_LIST_GROUP_BASED_STAGE_DATA_DELETE =
  "/communication/ims/schedule/list/{planAssociationId}/{groupTypeLkpId}/{groupId}";
export const PARTIAL_PAYOUT_DATE = "/scheme-planning/ims/partialPayoutDate?schemeId={programId}";
export const PREVIOUS_PAYOUT_COMMUNICATION_FOR_PROGRAM = "/communication/ims/payoutCommunication/getPreviousPayoutCommunicationsForProgram";
export const SCHEDULE_BULK_EMAIL = "/communication/ims/schedule/bulkEmail";
export const SCHEDULE_JOB_ROLE_NAME_BULK = "/communication/ims/schedule/jobRoleNames/bulk";
export const SCHEDULE_PLAN_RENDER_EMAIL_UPLOAD_ERROR_FILE_DOWNLOAD = "/communication/ims/schedule/downloadFile/{scheduleNo}";
export const PAYOUT_COMMUNICATION_IN_PROGRESS_ASYNC = "/communication/ims/payoutCommunication/renderInProgress";
export const PARTIAL_SUCCEEDED_STATUS = "/communication/ims/email/delivery-status/detail/{scheduleId}";
export const PARTIAL_SUCCEEDED_STATUS_DOWNLOAD = "/communication/ims/email/delivery-status/export/{scheduleId}";
